











import Vue from 'vue'
export default Vue.extend({
  name: 'IconFlagBadge',
  props: {
    number: {
      type: Number,
      default: 0,
    },
  },
})
